import React,{useContext} from "react";
import { Context } from '../../context/Context'

const FeaturesCfd = () => {
  const {cfd} = useContext(Context)
  const {title4, description4} = cfd
  return (
    <>
      <div className="overflow-hidden">
        <section id="about" className="about-us ptb-100" style={{backgroundColor:'#f1f6fc'}}>
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-7">
                <div className="about-content-left section-heading">
                  <h2>
                  {title4}
                  </h2>
                  <div className="single-feature mb-4">
                 <p> <div dangerouslySetInnerHTML={{__html:description4}}/></p>

                  </div>  </div>  
              </div>
              <div className="col-md-5">
                <div className="about-content-right">
                  {cfd?.animations?.[2] && (
                      <video autoPlay loop muted playsInline style={{width: '100%'}}>
                        <source src={cfd.animations[2]} type="video/mp4"/>
                        Your browser does not support the video tag.
                      </video>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FeaturesCfd;
